<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>
          Devoluções
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4" lg="3">
              <core-table-filter
                label="Buscar devolução"
                prepend-inner-icon="mdi-magnify"
                clearable
                single-line
              ></core-table-filter>
            </v-col>
            <v-col class="text-right d-none d-md-inline">
              <v-btn to="/devolucoes/nova" color="red" dark>
                <v-icon left>mdi-plus</v-icon>
                Nova devolução
              </v-btn>
            </v-col>
          </v-row>
          <v-btn
            to="/devolucoes/nova"
            class="d-md-none"
            color="red"
            fab
            fixed
            bottom
            right
            dark
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <core-table
            index-url="/devolucoes"
            :headers="headers"
            sort-by="created_at"
            sort-desc
            :itemsPerPageOptions="[5, 10, 15, 50]"
          >
            <template v-slot:item.cliente="{ item }">
              <span v-if="item.cliente_id">
                {{ item.cliente }}
              </span>
              <span v-else class="text--disabled">
                Sem cliente
              </span>
            </template>

            <template v-slot:item.cancelado="{ item }">
              <v-chip v-if="item.cancelado" color="red" dark label small>
                Cancelado
              </v-chip>
              <v-chip v-else label small>
                Realizado
              </v-chip>
            </template>

            <template v-slot:item.created_at="{ item }">
              {{ formatDateTime(item.created_at) }}
            </template>

            <template v-slot:item.total="{ item }">
              {{ formatMoney(item.total) }}
            </template>

            <template v-slot:item.numero="{ item }">
              <router-link :to="`/devolucoes/${item.numero}`">
                {{ item.numero }}
              </router-link>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn :to="`devolucoes/${item.numero}`" icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </core-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import CoreTable from "@/components/CoreTable";
import CoreTableFilter from "@/components/CoreTableFilter";
import MoneyMixin from "@/mixins/MoneyMixin";
import DateTimeMixin from "@/mixins/DateTimeMixin";

export default {
  mixins: [MoneyMixin, DateTimeMixin],
  components: { CoreTable, CoreTableFilter },
  data: function() {
    return {
      items: [],
      headers: [
        {
          text: "Número",
          value: "numero"
        },
        {
          text: "Cliente",
          value: "cliente"
        },
        {
          text: "Data",
          value: "created_at"
        },
        {
          text: "Total",
          value: "total"
        },
        {
          text: "Status",
          value: "cancelado"
        },
        {
          text: "",
          value: "actions",
          align: "center",
          sortable: false
        }
      ]
    };
  }
};
</script>
